
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";

export interface PasswordFieldProps {
  form: UseFormReturn<any>;
  showRequirements?: boolean;
  disabled?: boolean;
}

const PasswordField: React.FC<PasswordFieldProps> = ({ form, showRequirements = false, disabled = false }) => {
  const [showPassword, setShowPassword] = useState(false);
  
  return (
    <FormField
      control={form.control}
      name="password"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Password</FormLabel>
          <div className="relative">
            <FormControl>
              <Input 
                type={showPassword ? "text" : "password"} 
                placeholder="Enter your password" 
                {...field}
                disabled={disabled}
              />
            </FormControl>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="absolute right-0 top-0 h-full px-3 py-1 hover:bg-transparent"
              onClick={() => setShowPassword(!showPassword)}
              disabled={disabled}
            >
              {showPassword ? (
                <EyeOff className="h-4 w-4 text-muted-foreground" />
              ) : (
                <Eye className="h-4 w-4 text-muted-foreground" />
              )}
              <span className="sr-only">{showPassword ? "Hide password" : "Show password"}</span>
            </Button>
          </div>
          <FormMessage />
          {showRequirements && (
            <div className="text-xs text-muted-foreground mt-2">
              Password must be at least 8 characters and include a mix of letters, numbers, and symbols.
            </div>
          )}
        </FormItem>
      )}
    />
  );
};

export default PasswordField;
